module.exports = __webpack_public_path__ + "img/shopping_cart_icon.db0ac369.svg";